import { render, staticRenderFns } from "./PropertySelect.vue?vue&type=template&id=6195095e&scoped=true"
import script from "./PropertySelect.vue?vue&type=script&lang=js"
export * from "./PropertySelect.vue?vue&type=script&lang=js"
import style0 from "./PropertySelect.vue?vue&type=style&index=0&id=6195095e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6195095e",
  null
  
)

export default component.exports